var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1374_10829)","key":0},React.createElement("path",{"d":"M9.77733 10.9859L10.3294 7.4527H6.93422V5.15612C6.93422 4.19001 7.40899 3.24598 8.92717 3.24598H10.4729V0.237235C9.55984 0.0909482 8.63728 0.0116075 7.71262 -0.000152588C4.91918 -0.000152588 3.09185 1.69468 3.09185 4.75863V7.4527H-0.0107422V10.9859H3.09185V19.5318H6.91212V10.9859H9.77733Z","fill":"#A22F82"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1374_10829"},React.createElement("rect",{"width":"10.4616","height":"19.532","fill":"white"})))]);
}

Facebook.defaultProps = {"width":"11","height":"20","viewBox":"0 0 11 20","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
